import React, { useState, useEffect } from 'react';
import { Divide as Hamburger } from 'hamburger-react';
import { Link } from 'react-router-dom';
import Image from '../Image/Image';
import logoWhiteDesktopPNG from '../../assets/images/logo-white-desktop.png';
import logoWhiteDesktopWebP from '../../assets/images/logo-white-desktop.webp';
import logoWhiteMobilePNG from '../../assets/images/logo-white-desktop.png';
import logoWhiteMobileWebP from '../../assets/images/logo-white-desktop.webp';
import logotipoWhiteDesktopPNG from '../../assets/images/logotipo-white-desktop.png';
import logotipoWhiteDesktopWebP from '../../assets/images/logotipo-white-desktop.webp';
import logotipoWhiteMobilePNG from '../../assets/images/logotipo-white-desktop.png';
import logotipoWhiteMobileWebP from '../../assets/images/logotipo-white-desktop.webp';
import './Header.scss';

const Header = () => {
  const [isMenuHide, setIsMenuHide] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      if (scrollPosition > lastScrollPosition && scrollPosition > 9) {
        setIsMenuHide(true);
      } else {
        setIsMenuHide(false);
      }

      setLastScrollPosition(scrollPosition);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollPosition]);

  const imageProps = lastScrollPosition > 9
    ? {
        pngDesktopSrc: logotipoWhiteDesktopPNG,
        webpDesktopSrc: logotipoWhiteDesktopWebP,
        webpMobileSrc: logotipoWhiteMobileWebP,
        pngMobileSrc: logotipoWhiteMobilePNG,
      }
    : {
        pngDesktopSrc: logoWhiteDesktopPNG,
        webpDesktopSrc: logoWhiteDesktopWebP,
        webpMobileSrc: logoWhiteMobileWebP,
        pngMobileSrc: logoWhiteMobilePNG,
      };

  return (
    <header className={`header ${isMenuHide ? 'hide' : ''}`}>
      <div className='container'>
        <Link to='/'>
          <Image
            {...imageProps}
            alt="María Belén Olivera"
            width={lastScrollPosition > 9 ? 120 : 150}
            height={100} 
          />
        </Link>

        <Hamburger toggled={isMenuOpen} toggle={setIsMenuOpen} color="#fff" label={isMenuOpen ? "Cerrar menú" : "Abrir menú"} />

        <nav className={`${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to='/servicios'>Servicios</Link></li>
            <li><Link to='/sobre-mi'>Sobre Mí</Link></li>
            <li><a href="https://wa.me/message/ALLSQ5C5J6CMN1" target="_blank"  rel="noreferrer noopener">Contacto</a></li>
            <li className='btn-agendar'><Link to='/agenda'>Agendar Consulta</Link></li>
          </ul>
          
          <Image pngDesktopSrc={logoWhiteDesktopPNG} webpDesktopSrc={logoWhiteDesktopWebP} webpMobileSrc={logoWhiteMobileWebP} pngMobileSrc={logoWhiteMobilePNG} alt="María Belén Olivera" width={200} height={125} loading="lazy" />
        </nav>
      </div>
    </header>
  );
};

export default Header;